module.exports = __webpack_public_path__ + "assets/img/Katalog_2024.64054a1d.jpg";